// Sentry initialization should be imported first
//import './lib/sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import UserApp from './entry-app';
import './config/globals.css';
import { createHead, UnheadProvider } from '@unhead/react/client';

const enableMSW = import.meta.env.VITE_ENABLE_MSW === 'true';
async function enableMocking() {
  if (!enableMSW) {
    return;
  }

  const { worker } = await import('./mocks/browser');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const head = createHead();

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <UnheadProvider head={head}>
        <UserApp />
      </UnheadProvider>
    </StrictMode>
  );
});
